import { Delete, Edit, Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';

interface Props {
  onUpdate: () => void;
  onDelete: () => void;

  onToggleHidden?: () => void;
  isHidden?: boolean;
}

function ListActionButtons({
  onUpdate,
  onDelete,
  onToggleHidden,
  isHidden,
}: Props) {
  const canToggleHidden = !!onToggleHidden && typeof isHidden === 'boolean';

  return (
    <Stack direction="row" spacing={1} justifyContent="flex-end">
      {canToggleHidden && (
        <Tooltip title={isHidden ? '표시' : '숨김'}>
          <IconButton
            size="small"
            onClick={onToggleHidden}
            aria-label={isHidden ? '표시' : '숨김'}
          >
            {isHidden ? (
              <Visibility sx={{ fontSize: 18 }} />
            ) : (
              <VisibilityOff sx={{ fontSize: 18 }} />
            )}
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title="수정">
        <IconButton size="small" onClick={onUpdate} aria-label="수정">
          <Edit sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="삭제">
        <IconButton size="small" onClick={onDelete} aria-label="삭제">
          <Delete sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}

export default ListActionButtons;
